import { render, staticRenderFns } from "./FilterResult.vue?vue&type=template&id=3454a280"
import script from "./FilterResult.vue?vue&type=script&lang=js"
export * from "./FilterResult.vue?vue&type=script&lang=js"
import style0 from "./FilterResult.vue?vue&type=style&index=0&id=3454a280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports